import React from 'react';
import { Badge } from 'antd';

const RankCircle = ({ text = '' } = {}) => (
  <Badge count={text} style={{ backgroundColor: '#fff', color: '#000', boxShadow: '0 0 0 1px #000 inset' }} />
);

export default RankCircle;
